import {I18n} from 'aws-amplify/utils';
import {SimplePageHeader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions';
import {config} from '../config';
import {ComponentsReloadButton} from '../buttons/ReloadButton';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton';
import {AddRecordButton} from '../buttons/AddRecordButton';
import {DeleteRecordButton} from '../buttons/DeleteRecordButton';
import {GenerateContactButton} from '../../test-data/buttons/GenerateContactButton';
import {isTestDataEnabled} from '../../test-data/isTestDataEnabled.ts';
import {ContactStatus} from '../types';
import {rbacActions} from "../../../config/rbac/actions.ts";

interface IndexPageHeaderProps {
    onFilterChange: (status: ContactStatus | null) => void;
}

const useTools = (onFilterChange: (status: ContactStatus | null) => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <FilterRecordsButton key='filter' onFilterChange={onFilterChange} defaultStatus={ContactStatus.ACTIVE}/>,
        <ComponentsReloadButton key='reload'/>
    ];

    // FNP-1577: generation WRITES contacts, so it sits behind the same permission
    // as creating one — otherwise it is a way around that permission. The stage
    // check is here as well as inside the button because the MOUNT decision is
    // what a test can observe, and a button that is never mounted is the FNP-1027
    // failure: green tests, unreachable control.
    if (isTestDataEnabled() && allowedActions.includes(rbacActions.CreateContact)) {
        tools.push(<GenerateContactButton key='generate'/>);
    }

    if (allowedActions.includes(rbacActions.DeleteContact)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateContact)) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = ({onFilterChange}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
